import { useState } from "react";
import { toast } from "sonner";
import { Loader2, OctagonX } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const LABELS = { build: "build", fill: "page fill / spill fix", rewrite: "page rewrite", rewrite_all: "rewrite-all", prices: "price clean-up",
  page_check: "page check", info: "info-box tidy", original: "uploaded-kit fill" };

export const StopJobsButton = ({ kit, reload }) => {
  const [busy, setBusy] = useState(false);
  const jobs = kit.running_jobs || [];
  if (!jobs.length) return null;
  const stop = async () => {
    setBusy(true);
    try {
      const r = await http.post(`/kits/${kit.id}/stop`);
      toast.success(`Stopped: ${r.data.stopped.join(", ") || "nothing was running"}. Finished work is kept.`);
      reload();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button data-testid="kit-stop-all-btn" onClick={stop} disabled={busy} title={`Running: ${jobs.map((j) => LABELS[j] || j).join(", ")}`}
      className="inline-flex items-center gap-2 rounded-sm bg-red-700 px-4 py-2 text-sm font-semibold text-white hover:bg-red-800 transition-colors disabled:opacity-60">
      {busy ? <Loader2 size={15} className="animate-spin" /> : <OctagonX size={15} />} Stop {jobs.length > 1 ? `all ${jobs.length} jobs` : LABELS[jobs[0]] || "job"}
    </button>
  );
};
